export default {
  // 更新体验版
  25302: '该版本已存在',

  // 小程序没授权给第三方
  // 41001: '小程序没授权',

  // 微信审核
  '-1': '系统繁忙',
  86000: '不是由第三方代小程序进行调用',
  86001: '不存在第三方的已经提交的代码',
  85006: '标签格式错误',
  85007: '页面路径错误',
  85008: '类目填写错误',
  85009: '已经有正在审核的版本',
  85010: 'item_list有项目为空',
  85011: '标题填写错误',
  85023: '审核列表填写的项目数不在1-5以内',
  85077: '小程序类目信息失效（类目中含有官方下架的类目，请重新选择类目）',
  86002: '小程序还未设置昵称、头像、简介。请先设置完后再重新提交',
  85085: '近7天提交审核的小程序数量过多，请耐心等待审核完毕后再次提交',
  85086: '提交代码审核之前需提前上传代码',
  85087: '小程序已使用 api navigateToMiniProgram请声明跳转 appid 列表后再次提交',
  87013: '当天撤销审核次数已用完，请改天再试',

  // 业务域名
  89019: '业务域名无更改，无需重复设置',
  89020: '尚未设置小程序业务域名，请先在第三方平台中设置小程序业务域名后在调用本接口',
  89021: '请求保存的域名不是第三方平台中已设置的小程序业务域名或子域名',
  89029: '业务域名数量超过限制',
  89231: '个人小程序不支持调用setwebviewdomain 接口',

  // 服务域名
  85015: '该账号不是小程序账号',
  85016: '域名数量超过限制',
  85017: '没有新增域名，请确认小程序已经添加了域名或该域名是否没有在第三方平台添加',
  85018: '域名没有在第三方平台设置',

  // 微信绑定
  85001: '微信号不存在或微信号设置为不可搜索',
  85002: '小程序绑定的体验者数量达到上限',
  85003: '微信号绑定的小程序体验者达到上限',
  85004: '微信号已经绑定',
};
